import { serviceMaker, methods, api } from "@/http/index.js";

export const getMessages = () =>
    serviceMaker(`/messages`, methods.GET, api.NGB);
export const getViewMessages = (id) =>
    serviceMaker(`/messages/${id}`, methods.GET, api.NGB);
export const getMessagesTemplate = () =>
    serviceMaker(`/messages/template`, methods.GET, api.NGB);
export const createmessages = (data) =>
    serviceMaker(`/messages`, methods.POST, api.NGB, data);
export const editmessages = (id, data) =>
    serviceMaker(`/messages/${id}`, methods.PUT, api.NGB, data);
export const deletemessages = (id) =>
    serviceMaker(`/messages/${id}`, methods.DELETE, api.NGB);